'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfigs = getConfigs;
exports.setConfigs = setConfigs;
exports.getValue = getValue;
exports.setValue = setValue;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var keyRegistry = ['PROXY_ENDPOINT', 'ATHLINKS_API_HOST', 'WEATHER_API_HOST', 'WEATHER_API_KEY'];

var configs = {
  //syracuseUrl: 'http://192.168.99.100:9000',
  syracuseUrl: 'http://127.0.0.1:9000'
  //syracuseUrl: 'https://frontdesk-dev.athlinks.com/ctlive'
};

/**
 * @param {string} key A config object key.
 * @throws Error if given an unknown config key.
 * @return {void} The given object.
 */
function _checkRegistry(key) {
  if (keyRegistry.indexOf(key) === -1) {
    throw new Error('Attempt to set an unknown key: `' + key + '`');
  }
}

/**
 * @return object The entire config object.
 */
function getConfigs() {
  return configs;
}

/**
 * @param {object} options Key/value pairs to add to the configs object.
 * @return {void}
 */
function setConfigs(options) {
  configs = Object.assign({}, configs, options);
}

/**
 * @param {string} key A config object key.
 * @param {bool|null} mustExist Optionally skip existence check (default true).
 * @return {mixed} The corresponding value for the given key.
 * @throws Error if the check is induced in combination w/ a non-existent key.
 */
function getValue(key, mustExist) {
  mustExist = mustExist === false ? false : true;

  if (mustExist === true && Object.keys(configs || {}).indexOf(key) === -1) {
    throw new Error('No such Config key `' + key + '`');
  }

  return configs[key] ? configs[key] : undefined;
}

/** 
 * @param {string} key A config object key.
 * @param {mixed} value Corresponding value for key.
 * @param {bool|null} inRegistry Optionally skip registry check (default true).
 * @return {void}
 * @throws Error if the given key isn't valid, when inRegistry is used.
 */
function setValue(key, value, inRegistry) {
  inRegistry === false || _checkRegistry(key);
  setConfigs(_defineProperty({}, key, value));
}


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/Configure.js
// module id = 28
// module chunks = 0